import { Paragraph } from '../../../../common/Atoms/Typography/Paragraph';
import { classNames } from '../../../../common/lib/classNames';
import { AgentTask } from '../../../services/api/aiAgentApi/aiAgent';

import { STATEMENT_DEFAULT_BODY, STATEMENT_DEFAULT_SUBJECT } from './constants';
import {
  asTaskArgString,
  asTaskArgsRecord,
  getEditableFieldsForTool,
  readResolvedTaskRecipientEmails,
} from './taskEditHelpers';

export function SendToolReadOnlyDetails({ task }: { task: AgentTask }) {
  const args = asTaskArgsRecord(task.args);
  const editableFields = getEditableFieldsForTool(task.tool_name);
  const showSubject = editableFields.includes(`subject`);
  const showBody = editableFields.includes(`body`);
  const subjectFallback = task.tool_name === `send_statement` ? STATEMENT_DEFAULT_SUBJECT : ``;
  const bodyFallback = task.tool_name === `send_statement` ? STATEMENT_DEFAULT_BODY : ``;
  const subjectValue = asTaskArgString(args.subject) || subjectFallback;
  const bodyValue = asTaskArgString(args.body) || bodyFallback;

  let recipientValue: string | undefined;

  switch (task.tool_name) {
  case `send_email_to_customer`:
    recipientValue = readResolvedTaskRecipientEmails(args) || `Default contact email`;
    break;
  case `resend_invoice_email`:
    recipientValue = readResolvedTaskRecipientEmails(args) || `Selected contact email on file`;
    break;
  case `send_sms_to_customer`:
    recipientValue = asTaskArgString(args.overrideNumber) || `Default contact number`;
    break;
  case `send_statement`:
    recipientValue = readResolvedTaskRecipientEmails(args) || `Selected contact email on file`;
    break;
  default:
    return null;
  }

  return (
    <div className={ `space-y-2` }>
      {
        recipientValue &&
        <div>
          <Paragraph
            size={ `xs` }
            variant={ `secondary` }
          >
            { `To` }
          </Paragraph>
          <Paragraph size={ `sm` }>
            { recipientValue }
          </Paragraph>
        </div>
      }
      {
        showSubject &&
        <div>
          <Paragraph
            size={ `xs` }
            variant={ `secondary` }
          >
            { `Subject` }
          </Paragraph>
          <Paragraph
            size={ `sm` }
            className={ subjectValue ? undefined : `italic text-gray-400` }
          >
            { subjectValue || `No subject` }
          </Paragraph>
        </div>
      }
      {
        showBody &&
        <div>
          <Paragraph
            size={ `xs` }
            variant={ `secondary` }
          >
            { `Message` }
          </Paragraph>
          <p className={ classNames(
            `mt-0.5 whitespace-pre-wrap text-sm`,
            bodyValue ? `text-gray-700` : `italic text-gray-400`,
          ) }>
            { bodyValue || `No message` }
          </p>
        </div>
      }
    </div>
  );
}
